import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Introducing() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-258" data-mp="1zdeu8ce02akm">
      <div className="mx-auto max-w-3xl px-4" data-id="element-259" data-mp="1zd56kvgfgfi3">
        <SectionHeading eyebrow="Introducing Third Molar Assessment Blueprint™" title="A Visual Framework for Organizing Third Molar Assessments" data-id="element-260" data-mp="1uetvkheebyya" />
        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85" data-id="element-261" data-mp="16mn15ns8e21i">
          <p className="font-display text-2xl font-bold leading-snug text-ink" data-id="element-262" data-mp="12p8v24zukadq">
            The problem isn’t necessarily that you need another textbook.
          </p>
          <p data-id="element-263" data-mp="1bn1ad95kji14">
            You may already have textbooks, lecture notes, clinical references, radiographs, and years of dental education.
          </p>
          <p data-id="element-264" data-mp="nw5g85dn4aqp">
            But having access to information doesn’t automatically make it easy to organize that information when reviewing a third
            molar case.
          </p>
          <p data-id="element-265" data-mp="13cqtcgg4yryw">
            You may need to consider the patient’s history, clinical findings, tooth position, anatomical relationships, radiographic
            information, potential complications, and the questions that remain unanswered.
          </p>
          <p data-id="element-266" data-mp="1i40wungsbj7l">And you need a way to bring those elements together.</p>
          <p data-id="element-267" data-mp="kfz6jx1dxuq3">That’s what I wanted to create with Third Molar Assessment Blueprint™.</p>
        </div>

        <ul className="mt-8 space-y-3" data-id="element-268" data-mp="petwdixrsjjp">
          {['Not another extensive textbook.', 'Not a collection of disconnected explanations.'].map(line => <li key={line} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 text-base font-semibold text-muted" data-id="element-269" data-mp="uclpuhe2cdq0">
              <XIcon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-270" data-mp="ydfe5bvf3ujf" />
              {line}
            </li>)}
          <li className="flex items-start gap-3 rounded-xl bg-navy px-4 py-4 text-base font-semibold leading-relaxed text-white" data-id="element-271" data-mp="29u5n32r870gq">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sky" aria-hidden="true" data-id="element-272" data-mp="aom29ibt7pv9" />
            But a structured visual reference that helps you navigate the assessment process, organize the information available, and
            recognize what requires further professional evaluation.
          </li>
        </ul>

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85" data-id="element-273" data-mp="epo0pwxwjxw6">
          <p data-id="element-274" data-mp="3n83n86zh7gtc">I designed it to be practical, reusable, and easy to navigate.</p>
          <p data-id="element-275" data-mp="3j70a3s8tbyvt">
            Something you can open when studying, preparing an educational case discussion, or organizing the information associated
            with a third molar assessment.
          </p>
        </div>

        <div className="mt-10" data-id="element-276" data-mp="3s53yqxf3hbru">
          <CtaButton label="I Want One Organized Third Molar Reference" data-id="element-277" data-mp="34h2tbxd7qbgn" />
        </div>
      </div>
    </section>;
}